import { FC } from 'react'
import { useCustomTheme } from '@/core/theme'
import { SegmentProps } from './Segment.types'
import {
    SegmentContainer,
    SegmentBar,
    SegmentText,
    SegmentArrow,
} from './Segment.styles'

const Segment: FC<SegmentProps> = ({ color, isSelected, text, location }) => {
    const theme = useCustomTheme()

    return (
        <SegmentContainer
            data-testid={`segment-${isSelected ? 'selected' : 'not-selected'}`}
        >
            <SegmentArrow
                color={color}
                isSelected={isSelected}
                data-testid="segment-arrow"
            />
            <SegmentBar
                color={color}
                isSelected={isSelected}
                location={location}
                data-testid={`segment-box-${isSelected ? 'selected' : 'not-selected'}`}
            />
            <SegmentText
                variant="xs-regular"
                component="span"
                data-testid="segment-text"
                color={
                    isSelected
                        ? theme.colors.greys[900]
                        : theme.colors.greys[500]
                }
                whiteSpaceRule="break-spaces"
            >
                {text}
            </SegmentText>
        </SegmentContainer>
    )
}

export default Segment
